import Vue from 'vue'
import vueSignature from 'vue-signature'

Vue.use(vueSignature)
